import React from 'react';
import { getFormValues, reduxForm } from 'redux-form/immutable';

// components
import { Link } from 'react-router';
import { connect } from 'react-redux';
import classNames from 'classnames';
import Button from '../../shared/form/_Button';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { Field } from 'redux-form/immutable';
import { currentManagerCreate } from '../../../actions/currentManagerActions';

const FORM_NAME = 'managerNew';

const OpeningInfo = ({ currentUser, token, _handleGoBack, createCurrentUser, formValues }) => {
  const loading = currentUser.get('loading') || token.get('loading');

  return (
    <div className='manager-new__step1'>
      <h2 className='manager-new__step3__description'>
          Next book opens
      </h2>
      <form className='manager-new__step3__form' onSubmit={ _handleSubmit(createCurrentUser, formValues) }>
        <div className='form__group'>
          <Field className='form__field form__field--rounded'
            component='input'
            name='office.openingInfo'
            type='text' />
        </div>
        <div className='form__submit'>
          <Link className={ classNames('form__button form__button--purple manager-new__form__button', { 'form__button--disabled': loading }) }
            to={ _handleGoBack }>
                        Back
          </Link>
          <Button className='form__button form__button--green manager-new__form__button'
            loading={ loading }>
                        Next
          </Button>
        </div>
      </form>

    </div>
  );
};

OpeningInfo.propTypes = {
  _handleBack: PropTypes.func,
  createCurrentUser: PropTypes.func.isRequired,
  currentUser: PropTypes.instanceOf(Immutable.Map),
  formValues: PropTypes.instanceOf(Immutable.Map),
  token: PropTypes.instanceOf(Immutable.Map)
};

const _handleSubmit = (createCurrentUser, formValues) => (e) => {
  e.preventDefault();

  const form = formValues || Immutable.Map();

  createCurrentUser(form.toJS());
};

const mapStateToProps = (state) => {
  return {
    currentUser: state.get('currentUser'),
    formValues:  getFormValues(FORM_NAME)(state),
    token:       state.get('token')
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    createCurrentUser: (form) => dispatch(currentManagerCreate(form))
  };
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(
    reduxForm(
      {
        destroyOnUnmount: false,
        form: FORM_NAME
      }
    )(OpeningInfo)
  ));



// WEBPACK FOOTER //
// ./app/components/managers/signUp/_OpeningInfo.jsx